import { render } from "./CarNameVin.vue?vue&type=template&id=06349b90&scoped=true&ts=true"
import script from "./CarNameVin.vue?vue&type=script&lang=ts"
export * from "./CarNameVin.vue?vue&type=script&lang=ts"

import "./CarNameVin.vue?vue&type=style&index=0&id=06349b90&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06349b90"]])

export default __exports__